import { memo } from 'react';
import { Stack } from '@chakra-ui/react';

import { HEADER_HEIGHTS } from 'constants/global';

const NewWrapper = ({ children, ...props }) => (
  <Stack
    direction="column"
    w="full"
    maxW={{ desktop: '1440px', mobile: 'full' }}
    boxSizing="border-box"
    align="start"
    gap={{ laptop: '180px', tablet: '120px', mobile: '80px' }}
    mt={HEADER_HEIGHTS}
    pt={{ laptop: '147px', tablet: '160px', mobile: '148px' }}
    px={{ laptop: '140px', tablet: '20px', mobile: '16px' }}
    pb={{ laptop: '180px', tablet: '120px', mobile: '80px' }}
    overflowX="hidden"
    pos="relative"
    zIndex="10"
    {...props}
  >
    {children}
  </Stack>
);

export default memo(NewWrapper);
